import {createContext} from "react";

export const TitleContext = createContext({
    title: '',
    button: null,
    setTitle: () => {
    },
    setButton: () => {
    }
});